module.exports = __webpack_public_path__ + "img/icon_study-time.f1ce8516.png";